import { render } from "./PokemonPicture.vue?vue&type=template&id=1d03120c&scoped=true"
import script from "./PokemonPicture.vue?vue&type=script&lang=js"
export * from "./PokemonPicture.vue?vue&type=script&lang=js"

import "./PokemonPicture.vue?vue&type=style&index=0&id=1d03120c&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\cursos\\udemy\\curso-vue-cero-experto\\04-pokemon-game\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d03120c"]])

export default __exports__